import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {
    EnumWizardUpgradeToasts,
    Id,
    ISceneAddBlock,
    ISchedule,
    ISelectedSceneSceneId,
    IUser
} from "../../../../interfaces";
import {BlockCategoryType, BlockLabels, IBlockLabelProp, IBlockLabelsRecords} from "../../scene-blocks/block-constants";
import {DialogNewScheduleComponent} from '../../../../components/dialog-new-schedule/dialog-new-schedule.component';
import {CdkDragDrop} from "@angular/cdk/drag-drop";
import {isHostLocal, isMimeTypeExists, moveInArray} from "../../../../common";
import {TranslocoService} from "@ngneat/transloco";
import {AppService, CommonService, LocalStoreService, SceneAddService, StoreSelectorsService} from "../../../../services";
import {FormControl} from "@angular/forms";
import {Compbaser} from "../../../../components/compbaser";
import {getFontIcons} from "../../../../common/get-icons";
import {mergeMap, take} from "rxjs/operators";
import {actionSelectedSchedule} from 'app/store/actions/user.actions';
import {SceneAddComponentDialog} from "../scene-add-component-dialog/scene-add-component-dialog";
import {getComponentDescription} from "../../../../common/get-component-description";
import {Router} from '@angular/router';
import {faPhotoFilm} from "@fortawesome/free-solid-svg-icons";
import {ToastrService} from "ngx-toastr";
import {of} from "rxjs";
import * as _ from "lodash";
import {Lib} from "../../../../../libs/Lib";

interface ISelectOption {
    id: string;
    name: string;
    groupIds?: Array<any>;
    blocks?: Array<IBlockLabelProp>;
    selected?: boolean;
}

const firstOrderCategories = ["Basic", "Playback"];

@Component({
    selector: 'app-scene-add-blocks',
    templateUrl: './scene-add-blocks.component.html',
    styleUrls: ['./scene-add-blocks.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SceneAddBlocksComponent extends Compbaser implements OnInit {

    @Input()
    set addBlockType(i_addBlockType: ISceneAddBlock) {
        this.m_addBlockType = i_addBlockType;
    }

    @Input()
    set categories(i_categories: Array<BlockCategoryType>) {
        if (i_categories && i_categories.length > 0) {
            this.m_initialCategories = i_categories;
            setTimeout(() => {
                this.hideCategoryDropdown = true;
                this.cdr.markForCheck();
            });
            if (this.categorySelections.length > 0) {
                this.applyInitialCategories();
            }
        }
    }

    @Output()
    closedDialog: EventEmitter<any> = new EventEmitter();

    sceneId: Id;
    sceneMime = '';
    enterpriseMode: boolean;
    isFullFeatures = false;
    isMimeBased = false;
    mimeName = '';
    hiddenPanel = true;
    schedules: Array<ISchedule> = [];
    m_addBlockType: ISceneAddBlock;
    arrayBlocks: Array<IBlockLabelProp> = [];
    categorySelected = new FormControl([]);
    categorySelections: Array<ISelectOption> = [];
    dialogCompAddRef: MatDialogRef<SceneAddComponentDialog>;
    contentView = 'app_view';
    order = 0;
    mimeTypeBlock: IBlockLabelProp;
    user: IUser;
    m_initialCategories: Array<BlockCategoryType> = [];
    hideCategoryDropdown = false;

    readonly faPhotoFilm = faPhotoFilm;

    constructor(private translocoService: TranslocoService,
                public storeSelector: StoreSelectorsService,
                public commonService: CommonService,
                protected override dialog: MatDialog,
                private toastr: ToastrService,
                private cdr: ChangeDetectorRef,
                private appService: AppService,
                private localStoreService: LocalStoreService,
                private router: Router,
                private sceneAddService: SceneAddService
    ) {
        super();
        this.arrayBlocks = [];
        this.createComponentCategories();
        // this.testShowBlockPricePackages();
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.listenSelectedSceneIdAndSceneItemId()
                .pipe(
                    mergeMap((v: ISelectedSceneSceneId) => {
                        this.sceneId = v.sceneId;
                        /** improve performance, if sceneMime is already set no need to check again **/
                        if (this.sceneMime) {
                            return of(null);
                        } else {
                            return this.storeSelector.getSceneMimeType(this.sceneId);
                        }
                    })
                )
                .subscribe((v) => {
                    if (!v) return;
                    this.sceneMime = v;
                    this.isMimeBased = !this.storeSelector.isMainSceneOrPlayer(this.sceneMime);
                    this.mimeName = this.storeSelector.mineToName(this.sceneMime);
                    this.mimeTypeBlock = this.isMimeBased ? this.storeSelector.getBlockLabelByMimeType(this.sceneMime, true) : this.storeSelector.getBlockLabelById('4102');
                    if (this.m_addBlockType === 'BLOCK_COMPONENTS' || this.m_addBlockType === 'BLOCK_COMPONENTS_VERBOSE') {
                        this.initAddBlockList();
                        this.sortCategories();
                    }
                })
        );
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                    this.enterpriseMode = i_user.enterprise;
                    // this.enterpriseMode = false;
                })
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );

        if (this.m_addBlockType === 'BLOCK_COMPONENTS' || this.m_addBlockType === 'BLOCK_SCHEDULER') {
            this.sceneAddService.setBlockType(this.m_addBlockType);
        }

        if (this.m_addBlockType === 'BLOCK_SCHEDULER') {
            this.cod(
                this.storeSelector.getSchedules().subscribe((i_items: ISchedule[]) => {
                    this.schedules = i_items;
                    this.initScheduleBlockList();
                })
            );
        }

        setTimeout(() => {
            this.hiddenPanel = false;
            this.cdr.markForCheck();
        }, 500);
    }

    toggleContentView() {
        this.contentView = (this.contentView == 'app_view') ? 'component_view' : 'app_view';
    }

    private createComponentCategories() {
        let categories = [];
        Object.values(BlockLabels).forEach((block: IBlockLabelProp, index) => {
            categories = _.union(categories, block.category);
        });
        categories.forEach((categoryName, index) => {
            this.categorySelections.push({
                id: String(index),
                name: categoryName,
                groupIds: [index]
            });
            this.categorySelected.value.push(String(index));
        });
        if (this.m_initialCategories && this.m_initialCategories.length > 0) {
            this.applyInitialCategories();
        }
    }

    private applyInitialCategories() {
        const selectedIds = [];
        this.categorySelections.forEach((category) => {
            if (this.m_initialCategories.includes(category.name as BlockCategoryType)) {
                selectedIds.push(category.id);
            }
        });
        this.categorySelected.setValue(selectedIds);
        this.updateCategorySelection();
    }

    private testComponent(block, v) {
        if (block.name == 'Input') {
            console.log('Found input ' + v);
        }
    }

    private testShowBlockPricePackages() {
        this.arrayBlocks = [];
        const blockLabelRecords: IBlockLabelsRecords = this.storeSelector.blockLabels;
        const free = [];
        const plus = [];
        const enterprise = [];
        Object.values(blockLabelRecords).forEach((block: IBlockLabelProp, index) => {
            if (block.free) free.push(block.name + ' ' + block.id);
            if (block.plus) plus.push(block.name + ' ' + block.id);
            if (block.enterprise) enterprise.push(block.name + ' ' + block.id);
        });
        console.log(free, plus, enterprise);
    }

    private initAddBlockList() {
        const isHostLocalized = isHostLocal();
        this.arrayBlocks = [];
        const blockLabelRecords: IBlockLabelsRecords = this.storeSelector.blockLabels;

        Object.values(blockLabelRecords).forEach((block: IBlockLabelProp, index) => {

            /** option 1: if block is not in release and not in full features remove it **/
            // if (block.release === false && this.isFullFeatures === false) {
            //     return;
            // }

            /** option 2: if block is not in release and not in local host remove it **/
            // if (block.release === false && isHostLocalized === false) {
            //     return;
            // }

            /** option 3: if block is not in release and not in local dev remove it **/
            // if (block.release === false && isHostLocalized === false) {
            //     return;
            // }

            /** option 4: If block is not in release always remove it **/
            if (block.release === false) {
                return;
            }

            if (block.id === blockLabelRecords.BLOCKCODE_SCENE.id) return;
            if (block.id === blockLabelRecords.MUSIC.id) return;
            if (block.id === blockLabelRecords.IMAGE.id) return;
            if (block.id === blockLabelRecords.VIDEO.id) return;
            if (block.id === blockLabelRecords.SVG.id) return;
            if (block.id === blockLabelRecords.GENERIC.id) return;

            // const isBlockIdJsonItemBased = this.storeSelector.isBlockIdJsonItemBased(block.id);
            const isBlockIdJsonBased = this.storeSelector.isBlockIdJsonBased(block.id);
            const isBlockItemBased = this.storeSelector.isBlockItemBased(block.id);
            const sceneItemMimeType: Array<string> = block.types;
            block.description = getComponentDescription(blockLabelRecords, block.id);

            /** ********************************** **/
            /**    handle category filter          **/
            /** ********************************** **/
            if (block.category.length === 0) return;
            let found = null;
            this.categorySelected.value.forEach((v, ind) => {
                this.categorySelections.forEach((c: any) => {
                    if (ind == 0) c.selected = false;
                    if (v === c.id) {
                        if (block.category.indexOf(c.name) > -1) {
                            found = true;
                        }
                        c.selected = true;
                    }
                });
            });

            if (!found) return;

            if (this.storeSelector.isMainSceneOrPlayer(this.sceneMime)) {
                /** ********************************** **/
                /** if scene is regular / not mimeType **/
                /** ********************************** **/

                /** remove if block is custom item based such as Catalog, Xml, Stocks but keep JSONITEM **/
                if (isBlockItemBased && (block.id !== blockLabelRecords.JSONITEM.id)) return;

                /** re-order enterprise in bottom  **/
                if (block.enterprise === true) {
                    this.arrayBlocks.push(block);
                } else {
                    this.arrayBlocks.unshift(block);
                }
            } else {
                /** ******************** **/
                /** if scene is mimeType **/
                /** ******************** **/

                /** do not add if block is not compatible with scene mimeType **/
                if (sceneItemMimeType && sceneItemMimeType?.length > 0 && !isMimeTypeExists(sceneItemMimeType, this.sceneMime))
                    return;

                /** do not add in legacy mime (Catalog / XML / Custom RSS / Stocks ) JSON Player, Json Viewer or Json item **/
                switch (this.sceneMime) {
                    case 'Stocks':
                    case 'Catalog':
                    case 'XML':
                    case 'CustomRss': {
                        // if (isBlockItemBased)
                        //     return;
                        if (block.id === blockLabelRecords.JSONITEM.id)
                            return;
                        if (block.id === blockLabelRecords.JSON_PLAYER.id)
                            return;
                        if (block.id === blockLabelRecords.JSON_VIEWER.id)
                            return;
                    }
                }

                /** do not add if block is compatible with scene mimeType, however it is a main player, for example allow Catalog item in a Catalog scene, but not allow Catalog main player in a Mime.Catalog scene **/
                if (sceneItemMimeType && sceneItemMimeType?.length > 0 && isMimeTypeExists(sceneItemMimeType, this.sceneMime) && isBlockIdJsonBased) {
                    return;
                }

                /** modify icon of json item per mimeType **/
                const i_block = this.setDefaultMimeIcon(block, sceneItemMimeType, isBlockItemBased, isBlockIdJsonBased);

                if (block.enterprise === true) {
                    /** re-order enterprise component to bottom  **/
                    this.arrayBlocks.push(block);
                } else {
                    /** re-order free component to top  **/
                    this.arrayBlocks.unshift(block);
                }
            }
        });

        /** special re-ordering **/
        if (this.storeSelector.isMainSceneOrPlayer(this.sceneMime)) {
            /** re-order so playlist on top **/
            const idx = this.arrayBlocks.findIndex((i_block) => i_block.id === blockLabelRecords.PLAYLIST.id);
            if (idx > -1) this.arrayBlocks = moveInArray(idx, 0, ...this.arrayBlocks);
        } else {
            /** re-order so if block is of mimeType of this scene type set it to top **/
            const idx = this.arrayBlocks.findIndex((i_block) => {
                const sceneItemMimeType: Array<string> = i_block.types;
                return sceneItemMimeType && sceneItemMimeType?.length > 0 && isMimeTypeExists(sceneItemMimeType, this.sceneMime);
            });
            if (idx > -1) this.arrayBlocks = moveInArray(idx, 0, ...this.arrayBlocks);
        }

        /** always make label the 2nd item in the component array **/
        const fromIndex = this.arrayBlocks.findIndex(val => val.id == BlockLabels.LABEL.id);
        this.arrayBlocks = moveInArray(fromIndex, 1, ...this.arrayBlocks);

        this.categorizeBlocks();
        setTimeout(() => {
            this.cdr.detectChanges();
        }, 333);
    }

    private initScheduleBlockList() {
        // if (this.arrayBlocks.length > 0) return;
        const schBlock: IBlockLabelProp = this.storeSelector.blockLabels.SCHEDULER;
        this.arrayBlocks = this.schedules.map((scheduler) => {
            const block: IBlockLabelProp = _.cloneDeep(schBlock);
            block.name = scheduler.schedule_name;
            block.metadata = scheduler.schedule_id;
            return block;
        });
        this.cdr.detectChanges();
    }

    updateCategorySelection() {
        this.initAddBlockList();
    }

    /** modify icon of json item per mimeType **/
    private setDefaultMimeIcon(i_block, sceneItemMimeType, isBlockItemBased, isBlockIdJsonBased): IBlockLabelProp {
        if (sceneItemMimeType && isBlockItemBased && sceneItemMimeType?.length > 0 && isMimeTypeExists(sceneItemMimeType, this.sceneMime)) {
            /** never modify original store data directly **/
            const block = _.cloneDeep(i_block);
            block.icon = getFontIcons({$: {id: this.sceneMime}}).icon;
            return block;
        }
        return i_block;
    }

    override openDialog(): void {
        this.dialogCompAddRef = this.dialog.open(SceneAddComponentDialog, {
            width: '90%',
            height: '90%',
            panelClass: 'custom-dlg-container',
            data: {Component: 'Add'}
        });
        this.dialogCompAddRef.afterClosed().subscribe(result => {
            if (result) {
            }
        });
    }

    addBlock(event) {
        this.sceneAddService.addBlock(event, null, true);
        this.cdr.detectChanges();
    }

    addBlockVerbose(block: IBlockLabelProp) {
        this.addBlock(block);
        this.closedDialog.emit();
    }

    dropBlock(event: CdkDragDrop<any>) {
        if (event.isPointerOverContainer) return;
        this.sceneAddService.dropBlock(event, null, true);
        this.cdr.detectChanges();
    }

    createNewScheduler() {
        if (Lib.IsFreeAccount(this.user)) {
            this.appService.openWizardUpgradeDialog(EnumWizardUpgradeToasts.REACHED_LIMIT_OF_FEATURE);
            return;
        }
        if (Lib.IsAccessBlocked(this.user)) {
            this.toastr.error(this.translocoService.translate('account.screenDisruption', {}, this.translocoService.getActiveLang()), '[ Contact live chat ]');
            return false;
        }
        // open dialog and allow user to name / desc of new schedule
        const newDlg = this.dialog.open(DialogNewScheduleComponent, {
            data: {
                showJump: true
            }
        });
        this.cod(
            newDlg.afterClosed()
                .pipe(take(1))
                .subscribe((data: ISchedule) => {
                    if (data) {
                        this.commonService.addSchedule(data);
                    }
                })
        );
    }

    jumpToSchedulers(block) {
        // route to scheduler and select proper schedule
        this.localStoreService.setStorageValConfig('scheduledEnabled', '1');
        this.storeSelector.dispatch(actionSelectedSchedule({
            scheduleSelection: {
                scheduler: {
                    scheduleId: block?.metadata || null,
                    unique: Math.random()
                }
            }
        }));
        this.router.navigateByUrl('/scheduler/editor');
    }

    sortCategories() {
        this.categorySelections.sort((a, b) => {
            if (this.order === 1) {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            } else if (this.order === 2) {
                return b.name.toLowerCase().localeCompare(a.name.toLowerCase());
            } else {
                if (firstOrderCategories.includes(a.name) && firstOrderCategories.includes(b.name)) {
                    if (firstOrderCategories.indexOf(a.name) > firstOrderCategories.indexOf(b.name)) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
                if (firstOrderCategories.includes(a.name)) return -1;
                if (firstOrderCategories.includes(b.name)) return 1;
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            }
        });
        this.order = (this.order + 1) % 3;
        this.cdr.detectChanges();
    }

    toggleAllCategories() {
        const allIds = this.categorySelections.map(c => c.id);
        const currentlySelected = this.categorySelected.value || [];

        if (currentlySelected.length === allIds.length) {
            this.categorySelected.setValue([]);
        } else {
            this.categorySelected.setValue(allIds);
        }
        this.updateCategorySelection();
    }

    get allCategoriesSelected(): boolean {
        const allIds = this.categorySelections.map(c => c.id);
        const currentlySelected = this.categorySelected.value || [];
        return currentlySelected.length === allIds.length;
    }

    private categorizeBlocks() {
        if (!this.arrayBlocks) return;
        this.categorySelections.forEach((cate: any) => {
            const blocks = this.arrayBlocks.filter((block) => block.category && block.category.includes(cate.name));
            cate.blocks = blocks;
        });
    }

    override destroy() {
        this.sceneAddService.setActiveBlockId(null);
        if (this.dialog) {
            this.dialog.closeAll();
        }
        super.destroy();
    }

    protected readonly Lib = Lib;
}
